import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";

export enum DimType {
    Highlight,
    Win,
    Cycle
}

export default function DimSymbolsCommand(symbols: SymbolComponent[], type: DimType): Contract<void> {
    const dimSymbolMethods: Array<() => Contract<void>> = [];

    for (const symbol of symbols) {
        dimSymbolMethods.push(getDimAction(symbol, type));
    }

    return new Parallel(dimSymbolMethods);
}

function getDimAction(symbol: SymbolComponent, type: DimType) {
    switch (type) {
        case DimType.Highlight:
            return () => symbol.highlightDim();
        case DimType.Win:
            return () => symbol.winDim();
        case DimType.Cycle:
            return () => symbol.cycleDim();
        default:
            throw new Error(`Invalid symbol dim type requested: "${DimType}"`);
    }
}
